import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { LoRaWANApplicationServer, NetworkApplicationServerClassName, NodeEdgeMapper } from '@iotv/datamodel-core';
import { isNonNaNNumber } from '@iotv/iotv-v3-types';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Chip, Stack, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { useEffect, useState } from 'react';
import { getItemsByType } from '../../../../data/Wideawake/wideawakeDataFns';
import { NetworkDataGrid } from './NetworkDataGrid';
const debug = process.env.REACT_APP_DEBUG && false;
export const NetworkList = () => {
    const newNEM = new NodeEdgeMapper();
    const [nodeEdgeMapper, setNodeEdgeMapper] = useState(new NodeEdgeMapper());
    const [queryTime, setQueryTime] = useState(undefined);
    const [loadingNetworks, setLoadingNetworks] = useState(false);
    const getNetworks = async () => {
        setLoadingNetworks(true);
        const res = await getItemsByType(NetworkApplicationServerClassName);
        debug && console.log('getGateways res', res);
        if (res.data) {
            newNEM.loadItems(res.data.Items);
            setNodeEdgeMapper(newNEM);
            setQueryTime(res.data.durationMs);
        }
        setLoadingNetworks(false);
    };
    useEffect(() => {
        getNetworks();
    }, []);
    const networks = nodeEdgeMapper.getNodesOfType(NetworkApplicationServerClassName).map((vob) => new LoRaWANApplicationServer(vob));
    return (_jsxs(Stack, { gap: 1, children: [_jsxs(Stack, { direction: "row", gap: 0.5, children: [_jsx(Chip, { label: _jsxs(Typography, { variant: "body2", children: ["Networks: ", networks.length] }) }, "networks"), isNonNaNNumber(queryTime) && _jsx(Chip, { label: _jsxs(Typography, { variant: "body2", children: ["Query time: ", queryTime, " ms"] }) }, "query_time"), _jsx(IconButton, { color: "primary", onClick: () => getNetworks(), sx: { padding: 0.5 }, children: _jsx(RefreshIcon, {}) })] }), _jsx(NetworkDataGrid, { loading: loadingNetworks, networks: networks })] }));
};
